<cm-table-layout>
    <cm-job-farm-groups-table></cm-job-farm-groups-table>
</cm-table-layout>

<router-outlet></router-outlet>
